
import BBQMicFormV2 from "@/views/App/Portal/PrivateCoaching/FirstInterview/BBQMICFormV2.vue";


const bbqRoutesPortalPrivateCoaching = [
    {
        path: 'bbq/first-interview/mic-v2/:id',
        name: 'bbqPrivateCoachingMicFirstInterviewV2Form',
        component: BBQMicFormV2
    },
];

export default bbqRoutesPortalPrivateCoaching;